import { render, staticRenderFns } from "./goods-baseInfo.vue?vue&type=template&id=600ec5b0&scoped=true&"
import script from "./goods-baseInfo.vue?vue&type=script&lang=js&"
export * from "./goods-baseInfo.vue?vue&type=script&lang=js&"
import style0 from "./goods-baseInfo.vue?vue&type=style&index=0&id=600ec5b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600ec5b0",
  null
  
)

export default component.exports